export interface Briefs {
	[idTimestamp: number]: {
		numOfFinals: number,
		brief: string,
		briefTimestamp: number
	};
}